<template>
  <div class="flex-lg-1 h-screen container-fluid vstack" style="padding-top: 3rem; overflow: auto;">
    <vue-element-loading :active="loading" :is-full-screen="true" spinner="ring"/>

    <div class="row">
      <div class="col-lg-3"></div>

      <div class="col-lg-6" style="margin-bottom: 5rem;">
        <div class="card mb-6">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div>
                <div class="d-flex align-items-center">
                  <div class="avatar avatar-lg bg-warning rounded-circle text-white" style="background-color: #796CFF !important;">
                    <svg data-v-72a142e8="" t="1646979744016" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="11215" width="200" height="200" class="login-icon">
                      <path data-v-72a142e8=""
                        d="M512 0A512 512 0 1 0 1024 512 512 512 0 0 0 512 0z m0 34.133333a477.476571 477.476571 0 0 1 359.862857 791.747048c-1.852952-5.36380999-3.657143-10.727619-5.753905-15.993905a377.465905 377.465905 0 0 0-198.70476199-204.312381 4.583619 4.583619 0 0 1-0.731428-0.292571 213.333333 213.333333 0 1 0-309.345524 0l-1.31657101 0.536381a376.88076201 376.88076201 0 0 0-198.119619 204.01980899 312.417524 312.417524 0 0 0-5.753905 15.99390501A477.476571 477.476571 0 0 1 512 34.133333z m119.466667 557.68990501a179.2 179.2 0 0 1-298.666667-133.12 179.2 179.2 0 1 1 298.666667 133.12z m-452.705524 262.241524c1.26781001-4.437333 2.438095-8.923429 3.803428-13.16571401A344.746667 344.746667 0 0 1 385.219048 629.955048a212.163048 212.163048 0 0 0 253.561904 0 343.82019001 343.82019001 0 0 1 202.70323799 210.944c1.365333 4.193524 2.535619 8.728381 3.75466701 13.16571399a476.696381 476.696381 0 0 1-666.428952 0z m0 0"
                        p-id="11216" fill="#ffffff"></path>
                    </svg>
                  </div>

                  <div class="ms-4">
                    <span class="h4 d-block mb-0">{{ showuserInfo.firstName }} {{ showuserInfo.lastName }}</span>
                    <small class="text-muted" v-if="showuserInfo.email">{{ showuserInfo.email }}</small>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="mb-12">
          <div class="mb-5">
            <h4>Contact Information</h4>
          </div>

          <form @submit.prevent="updatedUser">
            <div class="row g-5">

              <div class="col-md-6 col-sm-6">
                <div>
                  <label class="form-label">First name</label>
                  <input type="text" class="form-control" ref="firstName" @blur="checkNameField" v-model.trim="showuserInfo.firstName">
                </div>
              </div>

              <div class="col-md-6 col-sm-6">
                <div>
                  <label class="form-label">Last name</label>
                  <input type="text" class="form-control" ref="lastName" @blur="checkNameField" v-model.trim="showuserInfo.lastName">
                </div>
              </div>

              <div class="col-md-12">
                <div>
                  <label class="form-label">Mobile number</label>
                  <input type="tel" class="form-control" v-model.trim="showuserInfo.mobile" @blur="checkMobileField" ref="mobile">
                  <p class="errrorMsg" v-if="showuserInfo.errorMobile">Invalid mobile number.</p>
                </div>
              </div>

              <div class="col-md-12">
                <div>
                  <label class="form-label">Job Title</label>
                  <input type="text" class="form-control" ref="jobTitle" v-model.trim="showuserInfo.jobTitle">
                </div>
              </div>

              <div class="col-12">
                <div>
                  <label class="form-label">Organisation</label>
                  <input type="text" class="form-control" ref="organisation" v-model.trim="showuserInfo.organisation">
                </div>
              </div>

              <div class="col-md-6">
                <div>
                  <label class="form-label">City</label>
                  <input type="text" class="form-control" v-model.trim="showuserInfo.city">
                </div>
              </div>

              <div class="col-md-6">
                <div>
                  <label class="form-label">Country</label>
                  <input type="text" class="form-control" v-model.trim="showuserInfo.country">
                </div>
              </div>

              <!-- change password toggle -->
              <div class="col-md-12">
                <div class="row" style="padding-left: 0.625rem;">
                  <div class="form-check form-switch me-n2 col-md-1">
                    <input class="form-check-input" type="checkbox" role="switch" v-model="checkVal">
                  </div>
                  <h6 class="text-danger col-md-8" style="line-height: 1.5rem;">
                    Whether to change the password.
                  </h6>
                </div>
              </div>

              <!-- password section -->
              <div v-if="checkVal" class="col-12">

                <div class="mb-2">
                  <label class="form-label">Old Password (required)</label>
                  <div class="outer">
                    <input
                      :type="showuserInfo.passwordType"
                      class="inner form-control"
                      style="width: 90%;"
                      ref="oldPassword"
                      v-model.trim="showuserInfo.oldPassword"
                      placeholder="Old password"
                      autocomplete="current-password"
                    >
                    <img class="eyes" :src="eyesImage" @click="clickEyes">
                  </div>
                </div>

                <div class="mb-2">
                  <label class="form-label">New Password</label>
                  <div class="outer">
                    <input
                      :type="showuserInfo.passwordType"
                      class="inner form-control"
                      style="width: 90%;"
                      ref="password"
                      @blur="checkPasswordField"
                      v-model.trim="showuserInfo.password"
                      placeholder="New password"
                      autocomplete="new-password"
                    >
                    <img class="eyes" :src="eyesImage" @click="clickEyes">
                  </div>
                  <p class="errrorMsg" v-if="showuserInfo.errorPw">Incorrect password format</p>
                  <p style="font-size: xx-small;color: rgba(107,123,147);">Use 6 ~ 20 characters.</p>
                </div>

                <div class="mb-2">
                  <label class="form-label">Confirm New Password</label>
                  <div class="outer">
                    <input
                      :type="showuserInfo.passwordType"
                      class="inner form-control"
                      style="width: 90%;"
                      ref="confirm"
                      @blur="confirmPw"
                      v-model.trim="showuserInfo.confirm"
                      placeholder="Confirm new password"
                      autocomplete="new-password"
                    >
                    <img class="eyes" :src="eyesImage" @click="clickEyes"/>
                  </div>
                  <p class="errrorMsg" v-if="showuserInfo.errorCon">Different passwords</p>
                </div>
              </div>

              <div class="col-12 text-end">
                <button type="submit" class="btn btn-sm btn-primary">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>

        <hr class="mb-12">
      </div>

      <div class="col-lg-3"></div>
    </div>
  </div>
</template>

<script>
import { Account } from "@/api"
import { checkMobile, isEmpty, checkName, checkPassword } from "@/utils/validate"

export default {
  name: "SettingsItem",
  data() {
    return {
      showuserInfo: {
        userId: "",
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        jobTitle: "",
        organisation: "",
        city: "",
        country: "",

        // change password
        oldPassword: "",
        password: "",
        confirm: "",
        passwordType: "password",

        errorName: false,
        errorMobile: false,
        errorPw: false,
        errorCon: false,
        eyesType: false
      },
      loading: false,
      userInfoRes: {},
      eyesImage: "./img/logos/close.png",
      checkVal: false
    }
  },

  methods: {
    // ===== Validators =====
    checkNameField() {
      const full = `${this.showuserInfo.firstName || ""}${this.showuserInfo.lastName || ""}`.trim()
      if (!isEmpty(full)) {
        this.showuserInfo.errorName = checkName(full)
      }
    },
    checkMobileField() {
      if (!isEmpty(this.showuserInfo.mobile)) {
        this.showuserInfo.errorMobile = checkMobile(this.showuserInfo.mobile)
      }
    },
    checkPasswordField() {
      if (!isEmpty(this.showuserInfo.password)) {
        this.showuserInfo.errorPw = checkPassword(this.showuserInfo.password)
      }
    },
    confirmPw() {
      if (!isEmpty(this.showuserInfo.password) && !isEmpty(this.showuserInfo.confirm)) {
        this.showuserInfo.errorCon = this.showuserInfo.password !== this.showuserInfo.confirm
      }
    },
    clickEyes() {
      this.showuserInfo.eyesType = !this.showuserInfo.eyesType
      if (this.showuserInfo.eyesType) {
        this.eyesImage = "./img/logos/open.png"
        this.showuserInfo.passwordType = "text"
      } else {
        this.eyesImage = "./img/logos/close.png"
        this.showuserInfo.passwordType = "password"
      }
    },

    // ===== Init =====
    async initUserInfo() {
      try {
        const res = await Account.getUserInfo()
        const record = res?.record
        const token = res?.token
        if (!record) throw new Error("Invalid auth")

        if (token) {
          localStorage.setItem("pb_token", token)
          localStorage.setItem("accessToken", token)
        }

        this.userInfoRes = { ...record }

        this.showuserInfo.userId = record.id
        this.showuserInfo.firstName = record.firstName || ""
        this.showuserInfo.lastName = record.lastName || ""
        this.showuserInfo.email = record.email || ""
        this.showuserInfo.jobTitle = record.jobTitle || ""
        this.showuserInfo.city = record.city || ""
        this.showuserInfo.country = record.country || ""
        this.showuserInfo.organisation = record.organisation || ""
        this.showuserInfo.mobile = record.mobile || ""
      } catch (e) {
        this.$MessageBox.alert("The login status is invalid, please log in again!", "Message", {
          confirmButtonText: "OK",
          callback: () => {
            localStorage.removeItem("pb_token")
            localStorage.removeItem("accessToken")
            this.$router.push({ name: "login" })
          }
        })
      }
    },

    // ===== Update =====
    async updatedUser() {
      if (isEmpty(this.showuserInfo.firstName) || this.showuserInfo.errorName) {
        alert("Please enter or modify First Name!")
        this.$refs.firstName.focus()
        return
      }
      if (isEmpty(this.showuserInfo.lastName) || this.showuserInfo.errorName) {
        alert("Please enter or modify Last Name!")
        this.$refs.lastName.focus()
        return
      }
      if (isEmpty(this.showuserInfo.mobile) || this.showuserInfo.errorMobile) {
        alert("Please enter or modify mobile number!")
        this.$refs.mobile.focus()
        return
      }
      if (isEmpty(this.showuserInfo.jobTitle)) {
        alert("Please enter or modify Job Title!")
        this.$refs.jobTitle.focus()
        return
      }
      if (isEmpty(this.showuserInfo.organisation)) {
        alert("Please enter or modify organisation!")
        this.$refs.organisation.focus()
        return
      }
      if (isEmpty(this.showuserInfo.city)) {
        alert("Please enter or modify city!")
        return
      }
      if (isEmpty(this.showuserInfo.country)) {
        alert("Please enter or modify country!")
        return
      }

      // password change validation
      if (this.checkVal) {
        if (isEmpty(this.showuserInfo.oldPassword)) {
          alert("Please enter old password!")
          this.$refs.oldPassword.focus()
          return
        }
        if (isEmpty(this.showuserInfo.password) || this.showuserInfo.errorPw) {
          alert("Please enter or modify new password!")
          this.$refs.password.focus()
          return
        }
        if (isEmpty(this.showuserInfo.confirm) || this.showuserInfo.errorCon) {
          alert("Please confirm new password!")
          this.$refs.confirm.focus()
          return
        }
      }

      const patch = {}
      const src = this.userInfoRes || {}

      const mapIfChanged = (key) => {
        if ((src[key] || "") !== (this.showuserInfo[key] || "")) patch[key] = this.showuserInfo[key]
      }

      mapIfChanged("firstName")
      mapIfChanged("lastName")
      mapIfChanged("mobile")
      mapIfChanged("jobTitle")
      mapIfChanged("organisation")
      mapIfChanged("city")
      mapIfChanged("country")

      if (this.checkVal) {
        patch.oldPassword = this.showuserInfo.oldPassword
        patch.password = this.showuserInfo.password
        patch.passwordConfirm = this.showuserInfo.confirm
      }

      if (Object.keys(patch).length === 0) {
        this.$MessageBox.alert("You have not changed any user data!", "Message", {
          confirmButtonText: "OK"
        })
        return
      }

      this.$MessageBox.alert("Are you sure to modify it?", "Message", {
        confirmButtonText: "OK",
        callback: async (val) => {
          if (val !== "confirm") return
          try {
            this.loading = true
            const res = await Account.updateMe(this.showuserInfo.userId, patch)
            this.loading = false

            // 改密码后强制重新登录（最稳）
            if (this.checkVal) {
              this.$MessageBox.alert("Password changed successfully, please log in again.", "Message", {
                confirmButtonText: "OK",
                callback: () => {
                  localStorage.removeItem("pb_token")
                  localStorage.removeItem("accessToken")
                  this.$router.push({ name: "login" })
                }
              })
              return
            }

            this.userInfoRes = { ...res }
            this.$MessageBox.alert("Modify successfully!", "Message", { confirmButtonText: "OK" })
          } catch (err) {
            this.loading = false
            const msg = err?.response?.data?.message || err?.message || "Update failed."
            this.$MessageBox.alert(msg, "Message", { confirmButtonText: "OK" })
          }
        }
      })
    }
  },

  mounted() {
    this.initUserInfo()
  }
}
</script>

<style>
.errrorMsg {
  color: #e30404;
  font-size: x-small;
}
.eyes {
  height: 1.5rem;
}
.outer {
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px rgb(50 50 71 / 8%);
  color: #16192c;
  display: block;
}
.inner {
  border: 0px solid #ffffff !important;
  border-radius: 0.375rem !important;
  box-shadow: 0 0px 0px rgb(255 255 255) !important;
  display: inline-block !important;
}
.inlinediv {
  display: inline-block !important;
}
.mr {
  margin-right: 0.25rem;
}
.ml {
  margin-left: 0.25rem;
}
.asterisk {
  width: 0.5rem;
}
</style>